
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7QWuh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b2b38f26dde8b259$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $b2b38f26dde8b259$export$2e2bcd8739ae039 = {
    'cross-flow-support.back-to-all-products': "\uC804\uCCB4 \uC571\uC73C\uB85C \uB3CC\uC544\uAC00\uAE30",
    'cross-flow-support.close': "\uB2EB\uAE30",
    'cross-flow-support.product-store': 'App Store'
};

});


//# sourceMappingURL=ko.9f203ea5.js.map
